/**
 * Legal-page chrome localized copy. Body prose stays English so the
 * English version remains legally authoritative — the disclaimer
 * banner rendered on non-English views makes that explicit.
 * See /locales/README.md.
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.legal,
  ht: ht.legal,
  fr: fr.legal,
  es: es.legal,
  'pt-BR': ptBR.legal,
  'zh-Hans': zhHans.legal,
}

export default COPY
